'use client';

import { c as _c } from "react/compiler-runtime";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import type { StandardTextFieldProps } from '@mui/material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import type { FC } from 'react';
import { useState } from 'react';
export const PasswordField: FC<Omit<StandardTextFieldProps, 'type'>> = props => {
  const $ = _c(16);
  const [showPassword, setShowPassword] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setShowPassword(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleToggleVisibility = t0;
  const t1 = showPassword ? "text" : "password";
  const t2 = props.slotProps?.input;
  const t3 = showPassword ? "Hide password" : "Show password";
  let t4;
  if ($[1] !== showPassword) {
    t4 = showPassword ? <VisibilityOff /> : <Visibility />;
    $[1] = showPassword;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = <InputAdornment position="end"><IconButton aria-label={t3} onClick={handleToggleVisibility} edge="end">{t4}</IconButton></InputAdornment>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t5) {
    t6 = {
      ...t2,
      endAdornment: t5
    };
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== props.slotProps || $[10] !== t6) {
    t7 = {
      ...props.slotProps,
      input: t6
    };
    $[9] = props.slotProps;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t7) {
    t8 = <TextField {...props} type={t1} slotProps={t7} />;
    $[12] = props;
    $[13] = t1;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp(prev) {
  return !prev;
}